export const BOOK = {
  title: "Hannah's Heart Awakens",
  subtitle: "A Children's Story About Discovering Jesus' Love",
  author: "Shaunta Scott",
  illustrator: "Saba Sardar",
  publisher: "Kharis Publishing",
  releaseDate: "2026-07-24T00:00:00",
  // $0.99 Kindle Launch Week runs July 24 – July 31, 2026 (ends 11:59 PM)
  launchWeekEnd: "2026-07-31T23:59:59",
  price: "$0.99",
  email: "hannahseriesofficial@gmail.com",
  brand: "Hannah Series Official",
  tagline: "Faith-filled stories, encouragement, and children's books that help point little hearts to Jesus.",
  facebook: "https://www.facebook.com/share/18vuEKJ8yP/?mibextid=wwXIfr",
  amazon: "https://a.co/d/0iHyfFsg",
  barnesNoble: "https://www.barnesandnoble.com/w/hannahs-heart-awakens-shaunta-scott/1150817426",
  walmart: "https://www.walmart.com/ip/20667853544",
  kharis: "https://kharispublishing.com/kp/product/hannahs-heart-awakens/",
  siteUrl: "https://shauntascott.com",
  amazonReview: "https://www.amazon.com/review/create-review/?ie=UTF8&channel=awUDPv3&asin=1637466846",
  goodreads: "https://www.goodreads.com/book/show/255545220-hannah-s-heart-awakens",
};

// Days the $0.99 launch-week price runs after release
const LAUNCH_WEEK_DAYS = 5;

// Returns 'preorder' | 'launchweek' | 'onsale' based on the current date.
export function getSaleState() {
  const now = Date.now();
  const promoEnd = new Date(BOOK.launchWeekEnd).getTime();
  if (now < promoEnd) return "launchweek";
  return "onsale";
}

export const RETAILERS = [
  { key: "amazon", label: "Amazon", url: "amazon" },
  { key: "barnesNoble", label: "Barnes & Noble", url: "barnesNoble" },
  { key: "walmart", label: "Walmart", url: "walmart" },
  { key: "kharis", label: "Kharis Publishing", url: "kharis" },
];

export const CHAPTERS = [
  {
    n: "01",
    title: "A Curious Heart",
    text:
      "Meet Hannah — a bright, tender-hearted seven-year-old full of questions about the world and the wonder just beyond it.",
  },
  {
    n: "02",
    title: "Summer with Aunt Grace",
    text:
      "Hannah spends her summer at Aunt Grace's cozy house, where warm mornings and gentle faith begin to stir something new inside her.",
  },
  {
    n: "03",
    title: "The Story That Moved Her",
    text:
      "One quiet night, Hannah watches the story of Jesus healing a blind man — and tears fall as her small heart is deeply touched.",
  },
  {
    n: "04",
    title: "Inviting Jesus In",
    text:
      "With Aunt Grace beside her, Hannah whispers a prayer and invites Jesus into her heart — the beautiful beginning of her awakening.",
  },
];

export const ILLUSTRATIONS = [
  { src: "/book/kitchen.png", alt: "Hannah and her mother in the kitchen", span: "md:col-span-7 md:row-span-2" },
  { src: "/book/arrival.png", alt: "Aunt Grace welcomes Hannah with open arms", span: "md:col-span-5" },
  { src: "/book/house.png", alt: "Hannah arrives at Aunt Grace's home", span: "md:col-span-5" },
  { src: "/book/tv.png", alt: "Hannah watching the story of Jesus", span: "md:col-span-6" },
  { src: "/book/bedside.png", alt: "A tender bedside moment with Aunt Grace", span: "md:col-span-6" },
  { src: "/book/tuckin.png", alt: "Aunt Grace tucks Hannah in for the night", span: "md:col-span-12" },
];

export const PRAISE = [
  {
    quote:
      "I am honored to endorse Hannah's Heart Awakens by Shaunta Scott, a beautifully written and spiritually rich story that tenderly leads children toward the love of Jesus. This book captures the heart of the gospel in a way young readers can understand and cherish. I wholeheartedly recommend it to families, ministries, and educators seeking Christ-centered literature for children.",
    name: "Pastor Kevin Handy",
    role: "New Life Begins Church",
  },
  {
    quote:
      "Hannah's Heart Awakens meets children right where they are—with hope, clarity, and a voice they can trust. As a mentor working with at-risk youth, I've seen how stories shape choices. Shaunta's book gives kids language for faith, invites families to talk about purpose, and offers a gentle path to peace. I believe this story will encourage parents, educators, and mentors alike.",
    name: "Derrick Collins",
    role: "Founder, Mr. & Mrs. Mentoring",
  },
  {
    quote:
      "Hannah's Heart Awakens is a God-inspired story that reaches beyond imagination — it reaches hearts. As both a mother and a grandmother, I believe this book carries the anointing to lead readers to salvation. It gently explains what it means to know Jesus personally and even includes the prayer of salvation, allowing children and families to invite Him into their hearts together. This book is more than a story — it's a ministry tool. Shaunta's obedience to God in writing it will touch countless families and help bring children into the Kingdom of God.",
    name: "Darlene Young",
    role: "Mother of the Author",
  },
  {
    quote:
      "It is with great honor and joy that I thank Shaunta Scott for stepping out on a faith limb securely connected to the Vine—ELOHIM. Her bold 'yes' to HOLY SPIRIT was a clear sign that she understood the call to share Hannah's Heart Awakens with those who have an ear to hear and a heart prepared to encounter a life-changing manifestation of ELOHIM's love. May the words leap off the pages and settle deeply within all who are listening for what HOLY SPIRIT desires to say.",
    name: "Victory",
    role: "Aunt of the Author",
  },
  {
    quote:
      "Hannah's Heart Awakens is one of those rare stories that gently opens a child's heart to explore God for themselves. I love how the author, Shaunta Scott, weaves prayer naturally into the narrative, giving young readers a beautiful example to follow. If you've never learned how to pray—or if you're just beginning your journey—this book is the perfect place to start.",
    name: "Altamead Ryans",
    role: "Teacher",
  },
];

export const MARQUEE_WORDS = ["Faith", "Wonder", "Jesus' Love", "Family", "Discovery", "Grace", "Hope"];
